import { parse, formatDistance, isBefore, subDays, isToday, differenceInHours, formatDistanceToNow, format, differenceInMinutes } from 'date-fns';

export function formatMessageDate(messageDate) {
  // Parse the date string into a Date object
  const parsedDate = parse(messageDate, 'yyyy-MM-dd', new Date());

  // Check if the message is within the last 24 hours
  if (isToday(parsedDate)) {
    // If within last 24 hours, return "Today"
    return "Today";
  }

  // Calculate the date 10 days ago
  const tenDaysAgo = subDays(new Date(), 10);

  // Check if the message is older than 10 days
  if (isBefore(parsedDate, tenDaysAgo)) {
    // If older than 10 days, return the actual date
    return parsedDate.toLocaleDateString(); // Return actual date
  } else {
    // If not older than 10 days but not today, return the relative distance
    return formatDistance(parsedDate, new Date(), { addSuffix: true }); // Return relative distance
  }
}

export function formatLastLoggedInDate(dateTime) {
  const now = new Date();
  const givenDate = new Date(dateTime);
  const hoursDifference = differenceInHours(now, givenDate);
  
  if (hoursDifference < 24) {
    return formatDistanceToNow(givenDate, { addSuffix: true });
  } else {
    return format(givenDate, 'hh:mm a / dd-MM-yyy');
  }
}

export function isUserLikelyOnline(dateTime) {
  const now = new Date();
  const givenDate = new Date(dateTime);
  return differenceInMinutes(now, givenDate) < 2;
}